import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useTestData, getTestLabel } from "context/TestDataContext";
import { useTranslation } from "i18n/LanguageContext";
import { useState, useEffect } from "react";

export default function CommentDialog({ open, handleClose, testName }) {
  const { testData, updateTest } = useTestData();
  const { t, lang } = useTranslation();
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (open) {
      setComment(testData[testName]?.comment || "");
    }
  }, [open, testName]);

  const handleSave = () => {
    updateTest(testName, { comment });
    handleClose();
  };

  const handleDelete = () => {
    updateTest(testName, { comment: "" });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6" color="primary">
          {t("common.comment")} — {getTestLabel(testName, testData[testName], lang)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <TextField
            autoFocus
            multiline
            minRows={3}
            maxRows={8}
            fullWidth
            placeholder={lang === "de" ? "Kommentar hinzufügen..." : "Ajouter un commentaire..."}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {testData[testName]?.comment && (
          <Button onClick={handleDelete} color="error" sx={{ mr: "auto" }}>
            {t("common.delete")}
          </Button>
        )}
        <Button onClick={handleClose}>{t("common.cancel")}</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
